var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-bf-node"},[_vm._v(" node"+_vm._s(_vm.itemData.id)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }